export const ESignatureModal: string = 'ESignatureModal';
